<template>
  <b-modal
    no-close-on-backdrop
    size="md"
    hide-footer
    id="new_category"
    title="NOVA CATEGORIA"
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <label-required-field label="TIPO" />
          <b-select v-model="stock_item_type_id">
            <b-select-option value=""> SELECIONE </b-select-option>
            <b-select-option
              v-for="option in types"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </b-select-option>
          </b-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label-required-field label="NOME" />
          <b-input type="text" ref="autofocus" v-model="name" />
        </b-col>
      </b-row>
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn :disabled="loading" type="submit" class="btn-save">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "SALVAR" }}
          </v-btn>
        </b-col>
      </b-row>
    </form>
  </b-modal>
</template>

<script>
import toast from "../../../../lib/ToastNotification";
import api from "../../../../services/api";
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import LabelRequiredField from "../../../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../../../Components/WarningRequiredFields.vue";

export default {
  name: "NewCategory",

  props: {
    types: Array,
  },

  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },

  data() {
    return {
      errors: [],
      loading: false,
      stock_item_type_id: "",
      name: "",
    };
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          stock_item_type_id: this.stock_item_type_id,
          name: this.name,
        };
        const response = await api.post(
          "/rest-home/stock/items/category",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("new_category");
          this.$emit("created");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>